import { render, staticRenderFns } from "./OpenPositionsDetailForm.vue?vue&type=template&id=041aa697"
import script from "./OpenPositionsDetailForm.vue?vue&type=script&lang=js"
export * from "./OpenPositionsDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports